// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file game/v1/envelope.proto (package game.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file game/v1/envelope.proto.
 */
export const file_game_v1_envelope: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Client -> Server
 *
 * @generated from message game.v1.ClientEnvelope
 */
export type ClientEnvelope = Message<"game.v1.ClientEnvelope"> & {
  /**
   * Версия wire-контракта.
   *
   * @generated from field: uint32 v = 1;
   */
  v: number;

  /**
   * Корреляция command <-> ack.
   * Для каждого нового command клиент увеличивает seq.
   *
   * @generated from field: uint64 seq = 2;
   */
  seq: bigint;

  /**
   * @generated from oneof game.v1.ClientEnvelope.body
   */
  body: {
    /**
     * @generated from field: game.v1.HelloCommand hello = 10;
     */
    value: HelloCommand;
    case: "hello";
  } | {
    /**
     * @generated from field: game.v1.CreateRoomCommand create_room = 11;
     */
    value: CreateRoomCommand;
    case: "createRoom";
  } | {
    /**
     * @generated from field: game.v1.JoinRoomCommand join_room = 12;
     */
    value: JoinRoomCommand;
    case: "joinRoom";
  } | {
    /**
     * @generated from field: game.v1.LeaveRoomCommand leave_room = 13;
     */
    value: LeaveRoomCommand;
    case: "leaveRoom";
  } | {
    /**
     * @generated from field: game.v1.StartGameCommand start_game = 14;
     */
    value: StartGameCommand;
    case: "startGame";
  } | {
    /**
     * @generated from field: game.v1.LoadedCommand loaded = 15;
     */
    value: LoadedCommand;
    case: "loaded";
  } | {
    /**
     * @generated from field: game.v1.SkipTutorialCommand skip_tutorial = 16;
     */
    value: SkipTutorialCommand;
    case: "skipTutorial";
  } | {
    /**
     * @generated from field: game.v1.DealerTurnCommand dealer_turn = 17;
     */
    value: DealerTurnCommand;
    case: "dealerTurn";
  } | {
    /**
     * @generated from field: game.v1.PlayerTurnCommand player_turn = 18;
     */
    value: PlayerTurnCommand;
    case: "playerTurn";
  } | {
    /**
     * @generated from field: game.v1.PlayerVoteCommand player_vote = 19;
     */
    value: PlayerVoteCommand;
    case: "playerVote";
  } | {
    /**
     * @generated from field: game.v1.ChangeAvatarCommand change_avatar = 20;
     */
    value: ChangeAvatarCommand;
    case: "changeAvatar";
  } | {
    /**
     * @generated from field: game.v1.ResumeCommand resume = 21;
     */
    value: ResumeCommand;
    case: "resume";
  } | {
    /**
     * @generated from field: game.v1.PauseRoomCommand pause_room = 22;
     */
    value: PauseRoomCommand;
    case: "pauseRoom";
  } | {
    /**
     * @generated from field: game.v1.ResumeRoomCommand resume_room = 23;
     */
    value: ResumeRoomCommand;
    case: "resumeRoom";
  } | {
    /**
     * @generated from field: game.v1.ContinueAfterMatchCommand continue_after_match = 24;
     */
    value: ContinueAfterMatchCommand;
    case: "continueAfterMatch";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message game.v1.ClientEnvelope.
 * Use `create(ClientEnvelopeSchema)` to create a new message.
 */
export const ClientEnvelopeSchema: GenMessage<ClientEnvelope> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 0);

/**
 * Server -> Client
 *
 * @generated from message game.v1.ServerEnvelope
 */
export type ServerEnvelope = Message<"game.v1.ServerEnvelope"> & {
  /**
   * Версия wire-контракта.
   *
   * @generated from field: uint32 v = 1;
   */
  v: number;

  /**
   * @generated from oneof game.v1.ServerEnvelope.body
   */
  body: {
    /**
     * ACKs
     *
     * @generated from field: game.v1.HelloAck hello_ack = 10;
     */
    value: HelloAck;
    case: "helloAck";
  } | {
    /**
     * @generated from field: game.v1.CreateRoomAck create_room_ack = 11;
     */
    value: CreateRoomAck;
    case: "createRoomAck";
  } | {
    /**
     * @generated from field: game.v1.JoinRoomAck join_room_ack = 12;
     */
    value: JoinRoomAck;
    case: "joinRoomAck";
  } | {
    /**
     * @generated from field: game.v1.LeaveRoomAck leave_room_ack = 13;
     */
    value: LeaveRoomAck;
    case: "leaveRoomAck";
  } | {
    /**
     * @generated from field: game.v1.StartGameAck start_game_ack = 14;
     */
    value: StartGameAck;
    case: "startGameAck";
  } | {
    /**
     * @generated from field: game.v1.LoadedAck loaded_ack = 15;
     */
    value: LoadedAck;
    case: "loadedAck";
  } | {
    /**
     * @generated from field: game.v1.SkipTutorialAck skip_tutorial_ack = 16;
     */
    value: SkipTutorialAck;
    case: "skipTutorialAck";
  } | {
    /**
     * @generated from field: game.v1.DealerTurnAck dealer_turn_ack = 17;
     */
    value: DealerTurnAck;
    case: "dealerTurnAck";
  } | {
    /**
     * @generated from field: game.v1.PlayerTurnAck player_turn_ack = 18;
     */
    value: PlayerTurnAck;
    case: "playerTurnAck";
  } | {
    /**
     * @generated from field: game.v1.PlayerVoteAck player_vote_ack = 19;
     */
    value: PlayerVoteAck;
    case: "playerVoteAck";
  } | {
    /**
     * @generated from field: game.v1.ChangeAvatarAck change_avatar_ack = 20;
     */
    value: ChangeAvatarAck;
    case: "changeAvatarAck";
  } | {
    /**
     * @generated from field: game.v1.ResumeAck resume_ack = 21;
     */
    value: ResumeAck;
    case: "resumeAck";
  } | {
    /**
     * @generated from field: game.v1.PauseRoomAck pause_room_ack = 22;
     */
    value: PauseRoomAck;
    case: "pauseRoomAck";
  } | {
    /**
     * @generated from field: game.v1.ResumeRoomAck resume_room_ack = 23;
     */
    value: ResumeRoomAck;
    case: "resumeRoomAck";
  } | {
    /**
     * @generated from field: game.v1.ContinueAfterMatchAck continue_after_match_ack = 24;
     */
    value: ContinueAfterMatchAck;
    case: "continueAfterMatchAck";
  } | {
    /**
     * Events
     *
     * @generated from field: game.v1.LobbyUpdatedEvent lobby_updated = 100;
     */
    value: LobbyUpdatedEvent;
    case: "lobbyUpdated";
  } | {
    /**
     * @generated from field: game.v1.PlayerReadyChangedEvent player_ready_changed = 101;
     */
    value: PlayerReadyChangedEvent;
    case: "playerReadyChanged";
  } | {
    /**
     * @generated from field: game.v1.MatchStartedEvent match_started = 102;
     */
    value: MatchStartedEvent;
    case: "matchStarted";
  } | {
    /**
     * @generated from field: game.v1.PhaseUpdatedEvent phase_updated = 103;
     */
    value: PhaseUpdatedEvent;
    case: "phaseUpdated";
  } | {
    /**
     * @generated from field: game.v1.DealerSelectedEvent dealer_selected = 104;
     */
    value: DealerSelectedEvent;
    case: "dealerSelected";
  } | {
    /**
     * @generated from field: game.v1.TutorialSkippedEvent tutorial_skipped = 105;
     */
    value: TutorialSkippedEvent;
    case: "tutorialSkipped";
  } | {
    /**
     * @generated from field: game.v1.HandDealtEvent hand_dealt = 106;
     */
    value: HandDealtEvent;
    case: "handDealt";
  } | {
    /**
     * @generated from field: game.v1.PhraseShownEvent phrase_shown = 107;
     */
    value: PhraseShownEvent;
    case: "phraseShown";
  } | {
    /**
     * @generated from field: game.v1.PlayerPlayedEvent player_played = 108;
     */
    value: PlayerPlayedEvent;
    case: "playerPlayed";
  } | {
    /**
     * @generated from field: game.v1.CardsShownEvent cards_shown = 109;
     */
    value: CardsShownEvent;
    case: "cardsShown";
  } | {
    /**
     * @generated from field: game.v1.PlayerVotedEvent player_voted = 110;
     */
    value: PlayerVotedEvent;
    case: "playerVoted";
  } | {
    /**
     * @generated from field: game.v1.VotingResultEvent voting_result = 111;
     */
    value: VotingResultEvent;
    case: "votingResult";
  } | {
    /**
     * @generated from field: game.v1.RoundResultEvent round_result = 112;
     */
    value: RoundResultEvent;
    case: "roundResult";
  } | {
    /**
     * @generated from field: game.v1.MatchResultEvent match_result = 113;
     */
    value: MatchResultEvent;
    case: "matchResult";
  } | {
    /**
     * @generated from field: game.v1.RoomPausedEvent room_paused = 114;
     */
    value: RoomPausedEvent;
    case: "roomPaused";
  } | {
    /**
     * @generated from field: game.v1.RoomClosedEvent room_closed = 115;
     */
    value: RoomClosedEvent;
    case: "roomClosed";
  } | {
    /**
     * @generated from field: game.v1.PlayerAvatarChangedEvent player_avatar_changed = 116;
     */
    value: PlayerAvatarChangedEvent;
    case: "playerAvatarChanged";
  } | {
    /**
     * @generated from field: game.v1.CardsPreloadEvent cards_preload = 117;
     */
    value: CardsPreloadEvent;
    case: "cardsPreload";
  } | {
    /**
     * @generated from field: game.v1.PostMatchStatusEvent post_match_status = 118;
     */
    value: PostMatchStatusEvent;
    case: "postMatchStatus";
  } | {
    /**
     * @generated from field: game.v1.TutorialSkipStatusEvent tutorial_skip_status = 119;
     */
    value: TutorialSkipStatusEvent;
    case: "tutorialSkipStatus";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message game.v1.ServerEnvelope.
 * Use `create(ServerEnvelopeSchema)` to create a new message.
 */
export const ServerEnvelopeSchema: GenMessage<ServerEnvelope> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 1);

/**
 * @generated from message game.v1.ErrorInfo
 */
export type ErrorInfo = Message<"game.v1.ErrorInfo"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message game.v1.ErrorInfo.
 * Use `create(ErrorInfoSchema)` to create a new message.
 */
export const ErrorInfoSchema: GenMessage<ErrorInfo> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 2);

/**
 * База для ack.
 * seq обязателен: сервер копирует seq из клиентского command.
 * ok = true  -> команда выполнена
 * ok = false -> команда отклонена, причина в error
 *
 * @generated from message game.v1.AckMeta
 */
export type AckMeta = Message<"game.v1.AckMeta"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from field: bool ok = 2;
   */
  ok: boolean;

  /**
   * @generated from field: game.v1.ErrorInfo error = 3;
   */
  error?: ErrorInfo | undefined;
};

/**
 * Describes the message game.v1.AckMeta.
 * Use `create(AckMetaSchema)` to create a new message.
 */
export const AckMetaSchema: GenMessage<AckMeta> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 3);

/**
 * @generated from message game.v1.PlayerBrief
 */
export type PlayerBrief = Message<"game.v1.PlayerBrief"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool ready = 3;
   */
  ready: boolean;

  /**
   * @generated from field: string avatar_id = 4;
   */
  avatarId: string;
};

/**
 * Describes the message game.v1.PlayerBrief.
 * Use `create(PlayerBriefSchema)` to create a new message.
 */
export const PlayerBriefSchema: GenMessage<PlayerBrief> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 4);

/**
 * @generated from message game.v1.RoomSnapshot
 */
export type RoomSnapshot = Message<"game.v1.RoomSnapshot"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string leader_id = 3;
   */
  leaderId: string;

  /**
   * @generated from field: string dealer_id = 4;
   */
  dealerId: string;

  /**
   * @generated from field: repeated game.v1.PlayerBrief players = 5;
   */
  players: PlayerBrief[];

  /**
   * @generated from field: uint32 round_no = 7;
   */
  roundNo: number;

  /**
   * @generated from field: uint32 max_round = 8;
   */
  maxRound: number;

  /**
   * @generated from field: bool has_deadline = 9;
   */
  hasDeadline: boolean;

  /**
   * @generated from field: int64 deadline_unix_ms = 10;
   */
  deadlineUnixMs: bigint;
};

/**
 * Describes the message game.v1.RoomSnapshot.
 * Use `create(RoomSnapshotSchema)` to create a new message.
 */
export const RoomSnapshotSchema: GenMessage<RoomSnapshot> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 5);

/**
 * @generated from message game.v1.Scores
 */
export type Scores = Message<"game.v1.Scores"> & {
  /**
   * @generated from field: map<string, int32> by_player_id = 1;
   */
  byPlayerId: { [key: string]: number };
};

/**
 * Describes the message game.v1.Scores.
 * Use `create(ScoresSchema)` to create a new message.
 */
export const ScoresSchema: GenMessage<Scores> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 6);

/**
 * @generated from message game.v1.ScoreDelta
 */
export type ScoreDelta = Message<"game.v1.ScoreDelta"> & {
  /**
   * @generated from field: map<string, int32> by_player_id = 1;
   */
  byPlayerId: { [key: string]: number };
};

/**
 * Describes the message game.v1.ScoreDelta.
 * Use `create(ScoreDeltaSchema)` to create a new message.
 */
export const ScoreDeltaSchema: GenMessage<ScoreDelta> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 7);

/**
 * @generated from message game.v1.HelloCommand
 */
export type HelloCommand = Message<"game.v1.HelloCommand"> & {
  /**
   * @generated from field: game.v1.Role role = 1;
   */
  role: Role;

  /**
   * Для player можно передать имя сразу.
   * Для screen обычно можно не передавать.
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message game.v1.HelloCommand.
 * Use `create(HelloCommandSchema)` to create a new message.
 */
export const HelloCommandSchema: GenMessage<HelloCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 8);

/**
 * @generated from message game.v1.TimerSetting
 */
export type TimerSetting = Message<"game.v1.TimerSetting"> & {
  /**
   * @generated from field: double seconds = 1;
   */
  seconds: number;

  /**
   * @generated from field: bool scale_by_players = 2;
   */
  scaleByPlayers: boolean;
};

/**
 * Describes the message game.v1.TimerSetting.
 * Use `create(TimerSettingSchema)` to create a new message.
 */
export const TimerSettingSchema: GenMessage<TimerSetting> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 9);

/**
 * @generated from message game.v1.RoomSettings
 */
export type RoomSettings = Message<"game.v1.RoomSettings"> & {
  /**
   * @generated from field: map<string, game.v1.TimerSetting> timers = 1;
   */
  timers: { [key: string]: TimerSetting };

  /**
   * @generated from field: bool skip_tutorial = 2;
   */
  skipTutorial: boolean;
};

/**
 * Describes the message game.v1.RoomSettings.
 * Use `create(RoomSettingsSchema)` to create a new message.
 */
export const RoomSettingsSchema: GenMessage<RoomSettings> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 10);

/**
 * @generated from message game.v1.CreateRoomCommand
 */
export type CreateRoomCommand = Message<"game.v1.CreateRoomCommand"> & {
  /**
   * @generated from field: game.v1.RoomSettings settings = 1;
   */
  settings?: RoomSettings | undefined;
};

/**
 * Describes the message game.v1.CreateRoomCommand.
 * Use `create(CreateRoomCommandSchema)` to create a new message.
 */
export const CreateRoomCommandSchema: GenMessage<CreateRoomCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 11);

/**
 * @generated from message game.v1.JoinRoomCommand
 */
export type JoinRoomCommand = Message<"game.v1.JoinRoomCommand"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message game.v1.JoinRoomCommand.
 * Use `create(JoinRoomCommandSchema)` to create a new message.
 */
export const JoinRoomCommandSchema: GenMessage<JoinRoomCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 12);

/**
 * @generated from message game.v1.LeaveRoomCommand
 */
export type LeaveRoomCommand = Message<"game.v1.LeaveRoomCommand"> & {
};

/**
 * Describes the message game.v1.LeaveRoomCommand.
 * Use `create(LeaveRoomCommandSchema)` to create a new message.
 */
export const LeaveRoomCommandSchema: GenMessage<LeaveRoomCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 13);

/**
 * @generated from message game.v1.StartGameCommand
 */
export type StartGameCommand = Message<"game.v1.StartGameCommand"> & {
};

/**
 * Describes the message game.v1.StartGameCommand.
 * Use `create(StartGameCommandSchema)` to create a new message.
 */
export const StartGameCommandSchema: GenMessage<StartGameCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 14);

/**
 * @generated from message game.v1.LoadedCommand
 */
export type LoadedCommand = Message<"game.v1.LoadedCommand"> & {
};

/**
 * Describes the message game.v1.LoadedCommand.
 * Use `create(LoadedCommandSchema)` to create a new message.
 */
export const LoadedCommandSchema: GenMessage<LoadedCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 15);

/**
 * @generated from message game.v1.SkipTutorialCommand
 */
export type SkipTutorialCommand = Message<"game.v1.SkipTutorialCommand"> & {
};

/**
 * Describes the message game.v1.SkipTutorialCommand.
 * Use `create(SkipTutorialCommandSchema)` to create a new message.
 */
export const SkipTutorialCommandSchema: GenMessage<SkipTutorialCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 16);

/**
 * @generated from message game.v1.DealerTurnCommand
 */
export type DealerTurnCommand = Message<"game.v1.DealerTurnCommand"> & {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId: string;

  /**
   * @generated from field: string phrase = 2;
   */
  phrase: string;
};

/**
 * Describes the message game.v1.DealerTurnCommand.
 * Use `create(DealerTurnCommandSchema)` to create a new message.
 */
export const DealerTurnCommandSchema: GenMessage<DealerTurnCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 17);

/**
 * @generated from message game.v1.PlayerTurnCommand
 */
export type PlayerTurnCommand = Message<"game.v1.PlayerTurnCommand"> & {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId: string;
};

/**
 * Describes the message game.v1.PlayerTurnCommand.
 * Use `create(PlayerTurnCommandSchema)` to create a new message.
 */
export const PlayerTurnCommandSchema: GenMessage<PlayerTurnCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 18);

/**
 * @generated from message game.v1.PlayerVoteCommand
 */
export type PlayerVoteCommand = Message<"game.v1.PlayerVoteCommand"> & {
  /**
   * @generated from field: string vote_card_id = 1;
   */
  voteCardId: string;
};

/**
 * Describes the message game.v1.PlayerVoteCommand.
 * Use `create(PlayerVoteCommandSchema)` to create a new message.
 */
export const PlayerVoteCommandSchema: GenMessage<PlayerVoteCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 19);

/**
 * @generated from message game.v1.ChangeAvatarCommand
 */
export type ChangeAvatarCommand = Message<"game.v1.ChangeAvatarCommand"> & {
  /**
   * @generated from field: string avatar_id = 1;
   */
  avatarId: string;
};

/**
 * Describes the message game.v1.ChangeAvatarCommand.
 * Use `create(ChangeAvatarCommandSchema)` to create a new message.
 */
export const ChangeAvatarCommandSchema: GenMessage<ChangeAvatarCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 20);

/**
 * @generated from message game.v1.ResumeCommand
 */
export type ResumeCommand = Message<"game.v1.ResumeCommand"> & {
  /**
   * @generated from field: game.v1.Role role = 1;
   */
  role: Role;

  /**
   * @generated from field: string room_code = 2;
   */
  roomCode: string;

  /**
   * для player
   *
   * @generated from field: string player_id = 3;
   */
  playerId: string;

  /**
   * @generated from field: string session_token = 4;
   */
  sessionToken: string;
};

/**
 * Describes the message game.v1.ResumeCommand.
 * Use `create(ResumeCommandSchema)` to create a new message.
 */
export const ResumeCommandSchema: GenMessage<ResumeCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 21);

/**
 * @generated from message game.v1.PauseRoomCommand
 */
export type PauseRoomCommand = Message<"game.v1.PauseRoomCommand"> & {
};

/**
 * Describes the message game.v1.PauseRoomCommand.
 * Use `create(PauseRoomCommandSchema)` to create a new message.
 */
export const PauseRoomCommandSchema: GenMessage<PauseRoomCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 22);

/**
 * @generated from message game.v1.ResumeRoomCommand
 */
export type ResumeRoomCommand = Message<"game.v1.ResumeRoomCommand"> & {
};

/**
 * Describes the message game.v1.ResumeRoomCommand.
 * Use `create(ResumeRoomCommandSchema)` to create a new message.
 */
export const ResumeRoomCommandSchema: GenMessage<ResumeRoomCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 23);

/**
 * @generated from message game.v1.ContinueAfterMatchCommand
 */
export type ContinueAfterMatchCommand = Message<"game.v1.ContinueAfterMatchCommand"> & {
};

/**
 * Describes the message game.v1.ContinueAfterMatchCommand.
 * Use `create(ContinueAfterMatchCommandSchema)` to create a new message.
 */
export const ContinueAfterMatchCommandSchema: GenMessage<ContinueAfterMatchCommand> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 24);

/**
 * @generated from message game.v1.HelloAck
 */
export type HelloAck = Message<"game.v1.HelloAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;

  /**
   * @generated from field: game.v1.Role role = 10;
   */
  role: Role;
};

/**
 * Describes the message game.v1.HelloAck.
 * Use `create(HelloAckSchema)` to create a new message.
 */
export const HelloAckSchema: GenMessage<HelloAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 25);

/**
 * @generated from message game.v1.CreateRoomAck
 */
export type CreateRoomAck = Message<"game.v1.CreateRoomAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;

  /**
   * @generated from field: string room_code = 10;
   */
  roomCode: string;

  /**
   * @generated from field: string session_token = 11;
   */
  sessionToken: string;

  /**
   * @generated from field: game.v1.RoomSnapshot snapshot = 12;
   */
  snapshot?: RoomSnapshot | undefined;
};

/**
 * Describes the message game.v1.CreateRoomAck.
 * Use `create(CreateRoomAckSchema)` to create a new message.
 */
export const CreateRoomAckSchema: GenMessage<CreateRoomAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 26);

/**
 * @generated from message game.v1.JoinRoomAck
 */
export type JoinRoomAck = Message<"game.v1.JoinRoomAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;

  /**
   * @generated from field: string room_code = 10;
   */
  roomCode: string;

  /**
   * @generated from field: string player_id = 11;
   */
  playerId: string;

  /**
   * @generated from field: string session_token = 12;
   */
  sessionToken: string;

  /**
   * @generated from field: game.v1.RoomSnapshot snapshot = 13;
   */
  snapshot?: RoomSnapshot | undefined;
};

/**
 * Describes the message game.v1.JoinRoomAck.
 * Use `create(JoinRoomAckSchema)` to create a new message.
 */
export const JoinRoomAckSchema: GenMessage<JoinRoomAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 27);

/**
 * @generated from message game.v1.LeaveRoomAck
 */
export type LeaveRoomAck = Message<"game.v1.LeaveRoomAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.LeaveRoomAck.
 * Use `create(LeaveRoomAckSchema)` to create a new message.
 */
export const LeaveRoomAckSchema: GenMessage<LeaveRoomAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 28);

/**
 * @generated from message game.v1.StartGameAck
 */
export type StartGameAck = Message<"game.v1.StartGameAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;

  /**
   * Если команду отправил лидер и матч стартовал -> MATCH_STARTED.
   * Если не лидер и просто toggled ready -> READY_TOGGLED.
   *
   * @generated from field: game.v1.StartGameResult result = 10;
   */
  result: StartGameResult;

  /**
   * Заполняется для READY_TOGGLED.
   *
   * @generated from field: bool ready = 11;
   */
  ready: boolean;
};

/**
 * Describes the message game.v1.StartGameAck.
 * Use `create(StartGameAckSchema)` to create a new message.
 */
export const StartGameAckSchema: GenMessage<StartGameAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 29);

/**
 * @generated from message game.v1.LoadedAck
 */
export type LoadedAck = Message<"game.v1.LoadedAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.LoadedAck.
 * Use `create(LoadedAckSchema)` to create a new message.
 */
export const LoadedAckSchema: GenMessage<LoadedAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 30);

/**
 * @generated from message game.v1.SkipTutorialAck
 */
export type SkipTutorialAck = Message<"game.v1.SkipTutorialAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.SkipTutorialAck.
 * Use `create(SkipTutorialAckSchema)` to create a new message.
 */
export const SkipTutorialAckSchema: GenMessage<SkipTutorialAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 31);

/**
 * @generated from message game.v1.DealerTurnAck
 */
export type DealerTurnAck = Message<"game.v1.DealerTurnAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.DealerTurnAck.
 * Use `create(DealerTurnAckSchema)` to create a new message.
 */
export const DealerTurnAckSchema: GenMessage<DealerTurnAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 32);

/**
 * @generated from message game.v1.PlayerTurnAck
 */
export type PlayerTurnAck = Message<"game.v1.PlayerTurnAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.PlayerTurnAck.
 * Use `create(PlayerTurnAckSchema)` to create a new message.
 */
export const PlayerTurnAckSchema: GenMessage<PlayerTurnAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 33);

/**
 * @generated from message game.v1.PlayerVoteAck
 */
export type PlayerVoteAck = Message<"game.v1.PlayerVoteAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.PlayerVoteAck.
 * Use `create(PlayerVoteAckSchema)` to create a new message.
 */
export const PlayerVoteAckSchema: GenMessage<PlayerVoteAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 34);

/**
 * @generated from message game.v1.ChangeAvatarAck
 */
export type ChangeAvatarAck = Message<"game.v1.ChangeAvatarAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.ChangeAvatarAck.
 * Use `create(ChangeAvatarAckSchema)` to create a new message.
 */
export const ChangeAvatarAckSchema: GenMessage<ChangeAvatarAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 35);

/**
 * @generated from message game.v1.ResumeAck
 */
export type ResumeAck = Message<"game.v1.ResumeAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;

  /**
   * @generated from field: string room_code = 2;
   */
  roomCode: string;

  /**
   * @generated from field: string player_id = 3;
   */
  playerId: string;

  /**
   * @generated from field: game.v1.RoomSnapshot snapshot = 4;
   */
  snapshot?: RoomSnapshot | undefined;

  /**
   * @generated from field: game.v1.PlayerPrivateState private_state = 5;
   */
  privateState?: PlayerPrivateState | undefined;

  /**
   * @generated from field: bool paused = 6;
   */
  paused: boolean;

  /**
   * @generated from field: string pause_reason = 7;
   */
  pauseReason: string;

  /**
   * @generated from field: int32 pause_ttl_sec = 8;
   */
  pauseTtlSec: number;
};

/**
 * Describes the message game.v1.ResumeAck.
 * Use `create(ResumeAckSchema)` to create a new message.
 */
export const ResumeAckSchema: GenMessage<ResumeAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 36);

/**
 * @generated from message game.v1.PauseRoomAck
 */
export type PauseRoomAck = Message<"game.v1.PauseRoomAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.PauseRoomAck.
 * Use `create(PauseRoomAckSchema)` to create a new message.
 */
export const PauseRoomAckSchema: GenMessage<PauseRoomAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 37);

/**
 * @generated from message game.v1.ResumeRoomAck
 */
export type ResumeRoomAck = Message<"game.v1.ResumeRoomAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.ResumeRoomAck.
 * Use `create(ResumeRoomAckSchema)` to create a new message.
 */
export const ResumeRoomAckSchema: GenMessage<ResumeRoomAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 38);

/**
 * @generated from message game.v1.ContinueAfterMatchAck
 */
export type ContinueAfterMatchAck = Message<"game.v1.ContinueAfterMatchAck"> & {
  /**
   * @generated from field: game.v1.AckMeta meta = 1;
   */
  meta?: AckMeta | undefined;
};

/**
 * Describes the message game.v1.ContinueAfterMatchAck.
 * Use `create(ContinueAfterMatchAckSchema)` to create a new message.
 */
export const ContinueAfterMatchAckSchema: GenMessage<ContinueAfterMatchAck> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 39);

/**
 * @generated from message game.v1.PlayerPrivateState
 */
export type PlayerPrivateState = Message<"game.v1.PlayerPrivateState"> & {
  /**
   * @generated from field: repeated string hand = 1;
   */
  hand: string[];

  /**
   * @generated from field: string own_played_card_id = 2;
   */
  ownPlayedCardId: string;

  /**
   * @generated from field: string own_vote_card_id = 3;
   */
  ownVoteCardId: string;

  /**
   * @generated from field: bool has_played = 4;
   */
  hasPlayed: boolean;

  /**
   * @generated from field: bool has_voted = 5;
   */
  hasVoted: boolean;

  /**
   * @generated from field: string phrase = 6;
   */
  phrase: string;

  /**
   * @generated from field: string dealer_card = 7;
   */
  dealerCard: string;

  /**
   * @generated from field: repeated string table_cards = 8;
   */
  tableCards: string[];

  /**
   * @generated from field: map<string, string> player_plays = 9;
   */
  playerPlays: { [key: string]: string };

  /**
   * @generated from field: map<string, string> player_votes = 10;
   */
  playerVotes: { [key: string]: string };

  /**
   * @generated from field: game.v1.ScoreDelta player_result_delta = 11;
   */
  playerResultDelta?: ScoreDelta | undefined;

  /**
   * @generated from field: game.v1.Scores player_results = 12;
   */
  playerResults?: Scores | undefined;
};

/**
 * Describes the message game.v1.PlayerPrivateState.
 * Use `create(PlayerPrivateStateSchema)` to create a new message.
 */
export const PlayerPrivateStateSchema: GenMessage<PlayerPrivateState> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 40);

/**
 * @generated from message game.v1.LobbyUpdatedEvent
 */
export type LobbyUpdatedEvent = Message<"game.v1.LobbyUpdatedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.RoomSnapshot snapshot = 2;
   */
  snapshot?: RoomSnapshot | undefined;
};

/**
 * Describes the message game.v1.LobbyUpdatedEvent.
 * Use `create(LobbyUpdatedEventSchema)` to create a new message.
 */
export const LobbyUpdatedEventSchema: GenMessage<LobbyUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 41);

/**
 * @generated from message game.v1.PlayerReadyChangedEvent
 */
export type PlayerReadyChangedEvent = Message<"game.v1.PlayerReadyChangedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;

  /**
   * @generated from field: bool ready = 3;
   */
  ready: boolean;
};

/**
 * Describes the message game.v1.PlayerReadyChangedEvent.
 * Use `create(PlayerReadyChangedEventSchema)` to create a new message.
 */
export const PlayerReadyChangedEventSchema: GenMessage<PlayerReadyChangedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 42);

/**
 * @generated from message game.v1.PlayerAvatarChangedEvent
 */
export type PlayerAvatarChangedEvent = Message<"game.v1.PlayerAvatarChangedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;

  /**
   * @generated from field: string avatar_id = 3;
   */
  avatarId: string;
};

/**
 * Describes the message game.v1.PlayerAvatarChangedEvent.
 * Use `create(PlayerAvatarChangedEventSchema)` to create a new message.
 */
export const PlayerAvatarChangedEventSchema: GenMessage<PlayerAvatarChangedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 43);

/**
 * @generated from message game.v1.MatchStartedEvent
 */
export type MatchStartedEvent = Message<"game.v1.MatchStartedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string leader_id = 3;
   */
  leaderId: string;

  /**
   * @generated from field: string dealer_id = 4;
   */
  dealerId: string;

  /**
   * @generated from field: uint32 round_no = 5;
   */
  roundNo: number;

  /**
   * @generated from field: uint32 max_round = 6;
   */
  maxRound: number;
};

/**
 * Describes the message game.v1.MatchStartedEvent.
 * Use `create(MatchStartedEventSchema)` to create a new message.
 */
export const MatchStartedEventSchema: GenMessage<MatchStartedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 44);

/**
 * @generated from message game.v1.PhaseUpdatedEvent
 */
export type PhaseUpdatedEvent = Message<"game.v1.PhaseUpdatedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string leader_id = 3;
   */
  leaderId: string;

  /**
   * @generated from field: string dealer_id = 4;
   */
  dealerId: string;

  /**
   * @generated from field: uint32 round_no = 5;
   */
  roundNo: number;

  /**
   * @generated from field: uint32 max_round = 6;
   */
  maxRound: number;

  /**
   * @generated from field: bool has_deadline = 7;
   */
  hasDeadline: boolean;

  /**
   * @generated from field: int64 deadline_unix_ms = 8;
   */
  deadlineUnixMs: bigint;
};

/**
 * Describes the message game.v1.PhaseUpdatedEvent.
 * Use `create(PhaseUpdatedEventSchema)` to create a new message.
 */
export const PhaseUpdatedEventSchema: GenMessage<PhaseUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 45);

/**
 * @generated from message game.v1.DealerSelectedEvent
 */
export type DealerSelectedEvent = Message<"game.v1.DealerSelectedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string dealer_id = 3;
   */
  dealerId: string;
};

/**
 * Describes the message game.v1.DealerSelectedEvent.
 * Use `create(DealerSelectedEventSchema)` to create a new message.
 */
export const DealerSelectedEventSchema: GenMessage<DealerSelectedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 46);

/**
 * @generated from message game.v1.TutorialSkippedEvent
 */
export type TutorialSkippedEvent = Message<"game.v1.TutorialSkippedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;
};

/**
 * Describes the message game.v1.TutorialSkippedEvent.
 * Use `create(TutorialSkippedEventSchema)` to create a new message.
 */
export const TutorialSkippedEventSchema: GenMessage<TutorialSkippedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 47);

/**
 * @generated from message game.v1.HandDealtEvent
 */
export type HandDealtEvent = Message<"game.v1.HandDealtEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;

  /**
   * @generated from field: repeated string cards = 3;
   */
  cards: string[];
};

/**
 * Describes the message game.v1.HandDealtEvent.
 * Use `create(HandDealtEventSchema)` to create a new message.
 */
export const HandDealtEventSchema: GenMessage<HandDealtEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 48);

/**
 * @generated from message game.v1.PhraseShownEvent
 */
export type PhraseShownEvent = Message<"game.v1.PhraseShownEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string phrase = 3;
   */
  phrase: string;
};

/**
 * Describes the message game.v1.PhraseShownEvent.
 * Use `create(PhraseShownEventSchema)` to create a new message.
 */
export const PhraseShownEventSchema: GenMessage<PhraseShownEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 49);

/**
 * @generated from message game.v1.PlayerPlayedEvent
 */
export type PlayerPlayedEvent = Message<"game.v1.PlayerPlayedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string player_id = 3;
   */
  playerId: string;
};

/**
 * Describes the message game.v1.PlayerPlayedEvent.
 * Use `create(PlayerPlayedEventSchema)` to create a new message.
 */
export const PlayerPlayedEventSchema: GenMessage<PlayerPlayedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 50);

/**
 * @generated from message game.v1.CardsShownEvent
 */
export type CardsShownEvent = Message<"game.v1.CardsShownEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: repeated string cards = 3;
   */
  cards: string[];
};

/**
 * Describes the message game.v1.CardsShownEvent.
 * Use `create(CardsShownEventSchema)` to create a new message.
 */
export const CardsShownEventSchema: GenMessage<CardsShownEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 51);

/**
 * @generated from message game.v1.PlayerVotedEvent
 */
export type PlayerVotedEvent = Message<"game.v1.PlayerVotedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string player_id = 3;
   */
  playerId: string;
};

/**
 * Describes the message game.v1.PlayerVotedEvent.
 * Use `create(PlayerVotedEventSchema)` to create a new message.
 */
export const PlayerVotedEventSchema: GenMessage<PlayerVotedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 52);

/**
 * @generated from message game.v1.VotingResultEvent
 */
export type VotingResultEvent = Message<"game.v1.VotingResultEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: string dealer_card = 3;
   */
  dealerCard: string;

  /**
   * @generated from field: map<string, string> player_plays = 4;
   */
  playerPlays: { [key: string]: string };

  /**
   * @generated from field: map<string, string> player_votes = 5;
   */
  playerVotes: { [key: string]: string };
};

/**
 * Describes the message game.v1.VotingResultEvent.
 * Use `create(VotingResultEventSchema)` to create a new message.
 */
export const VotingResultEventSchema: GenMessage<VotingResultEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 53);

/**
 * @generated from message game.v1.RoundResultEvent
 */
export type RoundResultEvent = Message<"game.v1.RoundResultEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: game.v1.RoundResultCode result_code = 3;
   */
  resultCode: RoundResultCode;

  /**
   * @generated from field: game.v1.ScoreDelta player_result_delta = 4;
   */
  playerResultDelta?: ScoreDelta | undefined;

  /**
   * @generated from field: game.v1.Scores player_results = 5;
   */
  playerResults?: Scores | undefined;
};

/**
 * Describes the message game.v1.RoundResultEvent.
 * Use `create(RoundResultEventSchema)` to create a new message.
 */
export const RoundResultEventSchema: GenMessage<RoundResultEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 54);

/**
 * @generated from message game.v1.MatchResultEvent
 */
export type MatchResultEvent = Message<"game.v1.MatchResultEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: game.v1.Scores player_results = 3;
   */
  playerResults?: Scores | undefined;
};

/**
 * Describes the message game.v1.MatchResultEvent.
 * Use `create(MatchResultEventSchema)` to create a new message.
 */
export const MatchResultEventSchema: GenMessage<MatchResultEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 55);

/**
 * @generated from message game.v1.RoomPausedEvent
 */
export type RoomPausedEvent = Message<"game.v1.RoomPausedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: uint32 ttl_sec = 3;
   */
  ttlSec: number;
};

/**
 * Describes the message game.v1.RoomPausedEvent.
 * Use `create(RoomPausedEventSchema)` to create a new message.
 */
export const RoomPausedEventSchema: GenMessage<RoomPausedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 56);

/**
 * @generated from message game.v1.RoomClosedEvent
 */
export type RoomClosedEvent = Message<"game.v1.RoomClosedEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message game.v1.RoomClosedEvent.
 * Use `create(RoomClosedEventSchema)` to create a new message.
 */
export const RoomClosedEventSchema: GenMessage<RoomClosedEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 57);

/**
 * @generated from message game.v1.CardsPreloadEvent
 */
export type CardsPreloadEvent = Message<"game.v1.CardsPreloadEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: repeated string card_ids = 3;
   */
  cardIds: string[];
};

/**
 * Describes the message game.v1.CardsPreloadEvent.
 * Use `create(CardsPreloadEventSchema)` to create a new message.
 */
export const CardsPreloadEventSchema: GenMessage<CardsPreloadEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 58);

/**
 * @generated from message game.v1.PostMatchStatusEvent
 */
export type PostMatchStatusEvent = Message<"game.v1.PostMatchStatusEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: repeated string continued_player_ids = 3;
   */
  continuedPlayerIds: string[];

  /**
   * @generated from field: uint32 continued_count = 4;
   */
  continuedCount: number;

  /**
   * @generated from field: uint32 players_count = 5;
   */
  playersCount: number;

  /**
   * @generated from field: uint32 remaining_count = 6;
   */
  remainingCount: number;
};

/**
 * Describes the message game.v1.PostMatchStatusEvent.
 * Use `create(PostMatchStatusEventSchema)` to create a new message.
 */
export const PostMatchStatusEventSchema: GenMessage<PostMatchStatusEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 59);

/**
 * @generated from message game.v1.TutorialSkipStatusEvent
 */
export type TutorialSkipStatusEvent = Message<"game.v1.TutorialSkipStatusEvent"> & {
  /**
   * @generated from field: string room_code = 1;
   */
  roomCode: string;

  /**
   * @generated from field: game.v1.Phase phase = 2;
   */
  phase: Phase;

  /**
   * @generated from field: repeated string voted_player_ids = 3;
   */
  votedPlayerIds: string[];

  /**
   * @generated from field: uint32 votes_count = 4;
   */
  votesCount: number;

  /**
   * @generated from field: uint32 players_count = 5;
   */
  playersCount: number;

  /**
   * @generated from field: uint32 remaining_count = 6;
   */
  remainingCount: number;
};

/**
 * Describes the message game.v1.TutorialSkipStatusEvent.
 * Use `create(TutorialSkipStatusEventSchema)` to create a new message.
 */
export const TutorialSkipStatusEventSchema: GenMessage<TutorialSkipStatusEvent> = /*@__PURE__*/
  messageDesc(file_game_v1_envelope, 60);

/**
 * @generated from enum game.v1.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_SCREEN = 1;
   */
  SCREEN = 1,

  /**
   * @generated from enum value: ROLE_PLAYER = 2;
   */
  PLAYER = 2,
}

/**
 * Describes the enum game.v1.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_game_v1_envelope, 0);

/**
 * @generated from enum game.v1.Phase
 */
export enum Phase {
  /**
   * @generated from enum value: PHASE_LOBBY = 0;
   */
  LOBBY = 0,

  /**
   * @generated from enum value: PHASE_LOADING = 1;
   */
  LOADING = 1,

  /**
   * @generated from enum value: PHASE_TUTORIAL = 2;
   */
  TUTORIAL = 2,

  /**
   * @generated from enum value: PHASE_SELECT_DEALER = 3;
   */
  SELECT_DEALER = 3,

  /**
   * @generated from enum value: PHASE_DEALER_TURN = 4;
   */
  DEALER_TURN = 4,

  /**
   * @generated from enum value: PHASE_SHOW_PHRASE = 5;
   */
  SHOW_PHRASE = 5,

  /**
   * @generated from enum value: PHASE_PLAYERS_TURN = 6;
   */
  PLAYERS_TURN = 6,

  /**
   * @generated from enum value: PHASE_SHOW_CARDS = 7;
   */
  SHOW_CARDS = 7,

  /**
   * @generated from enum value: PHASE_VOTING = 8;
   */
  VOTING = 8,

  /**
   * @generated from enum value: PHASE_VOTING_RESULTS = 9;
   */
  VOTING_RESULTS = 9,

  /**
   * @generated from enum value: PHASE_ROUND_RESULT = 10;
   */
  ROUND_RESULT = 10,

  /**
   * @generated from enum value: PHASE_MATCH_RESULT = 11;
   */
  MATCH_RESULT = 11,

  /**
   * @generated from enum value: PHASE_POST_MATCH = 12;
   */
  POST_MATCH = 12,
}

/**
 * Describes the enum game.v1.Phase.
 */
export const PhaseSchema: GenEnum<Phase> = /*@__PURE__*/
  enumDesc(file_game_v1_envelope, 1);

/**
 * @generated from enum game.v1.StartGameResult
 */
export enum StartGameResult {
  /**
   * @generated from enum value: START_GAME_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: START_GAME_RESULT_MATCH_STARTED = 1;
   */
  MATCH_STARTED = 1,

  /**
   * @generated from enum value: START_GAME_RESULT_READY_TOGGLED = 2;
   */
  READY_TOGGLED = 2,
}

/**
 * Describes the enum game.v1.StartGameResult.
 */
export const StartGameResultSchema: GenEnum<StartGameResult> = /*@__PURE__*/
  enumDesc(file_game_v1_envelope, 2);

/**
 * @generated from enum game.v1.RoundResultCode
 */
export enum RoundResultCode {
  /**
   * @generated from enum value: ROUND_RESULT_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROUND_RESULT_CODE_ALL_GUESSED = 1;
   */
  ALL_GUESSED = 1,

  /**
   * @generated from enum value: ROUND_RESULT_CODE_NOBODY_GUESSED = 2;
   */
  NOBODY_GUESSED = 2,

  /**
   * @generated from enum value: ROUND_RESULT_CODE_BALANCED = 3;
   */
  BALANCED = 3,
}

/**
 * Describes the enum game.v1.RoundResultCode.
 */
export const RoundResultCodeSchema: GenEnum<RoundResultCode> = /*@__PURE__*/
  enumDesc(file_game_v1_envelope, 3);

